import {Link, LinkProps} from '@material-ui/core'
import React from 'react'
import {Link as RouterLink} from 'react-router-dom'

export const InAppLink: React.FC<LinkProps<RouterLink>> = (props) => (
  <Link component={RouterLink} {...props} />
)
